/* Spinny Laschen-Regal: Auswahl, Datenblatt, Spot. Preise und Lieferbarkeit kommen live aus der Spinny-Kollektion. */
(() => {
  const CAT = {
    innen: {
      starter: {
        '1': 'nivilli-spinny-pro-starter-set-1mm-3-15mm-150-spin-tabs-75-caps',
        '1,5': 'nivilli-spinny-pro-starter-set-1-5mm-3-15mm-150-spin-tabs-75-caps',
        '2': 'nivilli-spinny-pro-starter-set-2mm-3-15mm-150-spin-tabs-75-spin-caps',
        '3': 'nivilli-spinny-pro-starter-set-3mm-3-15mm-150-spin-tabs-75-caps',
      },
      refill: { handle: 'nivilli-spinny-spin-tabs-1mm-1-5mm-2mm-3mm-laschen-3-15mm', price: 21.9,
        variant: { '1': 43541561671944, '1,5': 43541561704712, '2': 43541561737480, '3': 43541561770248 } },
      big: {
        '1': 'nivilli-spinny-700-stk-spin-tabs-laschen-1mm-3-15mm-big-pack',
        '1,5': 'nivilli-spinny-700-stk-spin-tabs-laschen-1-5mm-3-15mm-big-pack',
        '2': 'nivilli-spinny-spin-tabs-laschen-2mm-3-15mm-big-pack-700-stk',
        '3': 'nivilli-spinny-700-stk-spin-tabs-laschen-3mm-3-15mm-big-pack-kopie',
      },
      staerke: '3–15 mm', einsatz: 'Standardfliesen &amp; Naturstein', label: 'Innen',
    },
    aussen: {
      starter: {
        '2': 'nivilli-spinny-pro-starter-set-2mm-6-25mm-150-spin-tabs-75-caps',
        '3': 'nivilli-spinny-pro-starter-set-3mm-6-25mm-150-spin-tabs-75-caps',
        '4': 'nivilli-spinny-pro-starter-set-4mm-6-25mm-150-spin-tabs-75-caps',
        '5': 'nivilli-spinny-pro-starter-set-5mm-6-25mm-150-spin-tabs-75-caps',
      },
      refill: { handle: 'nivilli-spinny-spin-tabs-2mm-3mm-4mm-5mm-laschen-8-25mm-fliesen', price: 23.9,
        variant: { '2': 44757380825352, '3': 45485581828360, '4': 44757380858120, '5': 44757380890888 } },
      big: {
        '3': 'nivilli-spinny-spin-tabs-laschen-3mm-8-25mm-big-pack-700stk',
        '4': 'nivilli-spinny-spin-tabs-laschen-4mm-8-25mm-big-pack-700stk',
        '5': 'nivilli-spinny-spin-tabs-laschen-5mm-8-25mm-big-pack-700stk',
      },
      staerke: '6–25 mm', einsatz: 'Außenbereich, Platten &amp; Naturstein', label: 'Außen',
    },
  };
  const CAPS100 = 'nivilli-spinny-spin-caps-zughauben-100-stk-passend-zu-allen';
  const CAPS250 = 'nivilli-spinny-spin-caps-zughauben-big-pack-250-stk-passend';
  const PLANI = 'nivilli-plani-unterlegscheiben-50-stk-passend-zu-allen-spin-tabs';

  function init(root) {
    if (!root || root.dataset.sprReady) return;
    root.dataset.sprReady = '1';
    const q = (s) => root.querySelector(`[data-spr-${s}]`);
    const regal = q('regal'), stage = q('stage'), panel = q('panel'), hero = q('hero'), bigtype = q('bigtype'), hint = q('hint');
    const btns = [...root.querySelectorAll('[data-spr-item]')];
    const items = btns.map((b) => ({ ...b.dataset, foot: parseFloat(b.dataset.foot), ar: parseFloat(b.dataset.ar) }));
    const CAP = items.findIndex((it) => it.kind === 'cap');
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const mobileMQ = matchMedia('(max-width: 760px)');
    const COLLECTION = root.dataset.collectionUrl || '/collections/nivilli-spinny-fliesen-nivelliersystem';
    let money;
    try { money = new Intl.NumberFormat('de-DE', { style: 'currency', currency: root.dataset.currency || 'EUR' }); }
    catch (e) { money = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }); }

    const PRODUCTS = {};
    try { JSON.parse(q('products').textContent).forEach((p) => { PRODUCTS[p.h] = p; }); } catch (e) { /* ohne Live-Daten: Fallback-Preise */ }
    const live = Object.keys(PRODUCTS).length > 0;

    function product(handle, fallback, variantId) {
      const p = PRODUCTS[handle];
      if (!p) return live ? null : { url: `/products/${handle}${variantId ? `?variant=${variantId}` : ''}`, price: fallback, available: true };
      let price = p.p / 100, available = p.a, url = p.u;
      if (variantId) {
        const v = p.v.find((x) => x.id === variantId);
        if (!v) return null;
        price = v.p / 100; available = v.a;
        url += `${url.includes('?') ? '&' : '?'}variant=${variantId}`;
      }
      return { url, price, available };
    }
    const perPiece = (price, n) => `${(price / n * 100).toFixed(1).replace('.', ',')} ct/Stk.`;

    function li(name, sub, prod, n) {
      if (!prod) return null;
      const el = document.createElement('li');
      const a = document.createElement('a');
      a.href = prod.url;
      a.innerHTML = '<span class="spr-pk-name"></span><span class="spr-pk-price"></span><span class="spr-pk-sub"></span>';
      a.querySelector('.spr-pk-name').textContent = name;
      const subEl = a.querySelector('.spr-pk-sub');
      subEl.textContent = n ? `${sub} · ${perPiece(prod.price, n)}` : sub;
      if (!prod.available) subEl.insertAdjacentHTML('beforeend', ' · <em>ausverkauft</em>');
      a.querySelector('.spr-pk-price').textContent = money.format(prod.price);
      el.appendChild(a);
      return el;
    }
    const specs = (rows) => rows.map(([k, v, num]) => `<div><dt>${k}</dt><dd${num ? ' class="num"' : ''}>${v}</dd></div>`).join('');
    const extras = () => [
      li('Spin-Caps Zughauben', '100 Stück', product(CAPS100, 24.9), 100),
      li('Spin-Caps Big Pack', '250 Stück', product(CAPS250, 59.9), 250),
      li('Plani Unterlegscheiben', '50 Stück · für empfindliche Oberflächen', product(PLANI, 14.9)),
    ].filter(Boolean);

    function fillPanel(it) {
      q('bar').style.setProperty('--c', it.hex);
      q('color').style.setProperty('--c', it.hex);
      if (it.kind === 'cap') {
        q('eyebrow').textContent = 'Spin-Cap · Zughaube';
        q('mm').textContent = 'Ø 55';
        q('color-text').innerHTML = 'Passt auf <b>alle 8 Spin-Tabs</b>';
        q('specs').innerHTML = specs([
          ['Durchmesser', 'Ø 55 mm', true], ['Passt auf', 'Alle Spin-Tabs, innen und außen'],
          ['Einsatz', 'Werkzeuglos von Hand auf Höhe drehen'], ['Nutzung', 'Unbegrenzt wiederverwendbar'],
        ]);
        q('h1').textContent = 'Steckt in';
        const starter = product(CAT.innen.starter['2'], 29.95);
        q('packs').replaceChildren(...[li('Starter-Set, alle 8 Größen', '75 Zughauben + 150 Laschen', starter && { ...starter, url: COLLECTION, available: true })].filter(Boolean));
        q('h2').textContent = 'Einzeln';
        q('extras').replaceChildren(...extras());
        q('cta').href = COLLECTION;
        q('cta-text').textContent = 'Das Spinny System im Shop';
      } else {
        const c = CAT[it.bereich];
        q('eyebrow').textContent = `Spin-Tab · ${c.label}`;
        q('mm').textContent = it.mm;
        q('color-text').innerHTML = `Laschenfarbe <b>${it.farbe}</b>`;
        q('specs').innerHTML = specs([
          ['Fugenbreite', `${it.mm} mm`, true], ['Fliesen&shy;stärke', c.staerke, true],
          ['Einsatz', c.einsatz], ['Zughaube', 'Spin-Cap Ø 55 mm, wiederverwendbar'],
        ]);
        q('h1').textContent = 'Steckt in';
        q('packs').replaceChildren(...[
          li('Starter-Set', '150 Laschen + 75 Zughauben', product(c.starter[it.mm], 29.95)),
          li('Nachfüllpack', '250 Laschen', product(c.refill.handle, c.refill.price, c.refill.variant[it.mm]), 250),
          c.big[it.mm] ? li('Big Pack', '700 Laschen', product(c.big[it.mm], 54.9), 700) : null,
        ].filter(Boolean));
        q('h2').textContent = 'Passt dazu';
        q('extras').replaceChildren(...extras());
        const sep = COLLECTION.includes('?') ? '&' : '?';
        q('cta').href = `${COLLECTION}${sep}fuge=${encodeURIComponent(it.mm)}${it.bereich === 'aussen' ? '&bereich=aussen' : ''}`;
        q('cta-text').textContent = `Alle ${it.mm}-mm-Gebinde im Shop`;
      }
      const neutral = it.farbe === 'Weiß' || it.farbe.includes('grau');
      stage.style.setProperty('--spr-glow', neutral ? '#8d9290' : it.hex);
      stage.style.setProperty('--spr-tone', it.hex);
      setBigtype(it.kind === 'cap' ? 'Spin-Cap' : `${it.mm} mm`);
    }

    let bigTimer = 0;
    function setBigtype(text) {
      if (bigtype.textContent === text) return;
      bigtype.classList.add('is-swap');
      clearTimeout(bigTimer);
      bigTimer = setTimeout(() => { bigtype.textContent = text; bigtype.classList.remove('is-swap'); }, reduce ? 0 : 260);
    }

    let sel = -1, lastBtn = null;
    function placeHero() {
      const sw = stage.clientWidth, sh = stage.clientHeight, m = mobileMQ.matches;
      const it = items[sel] || items[0];
      const heroH = sh * (it.kind === 'cap' ? (m ? .29 : .36) : (m ? .5 : .58)), hb = m ? .84 : .82;
      stage.style.setProperty('--hero-h', `${heroH}px`);
      let hx = sw / 2;
      if (!m) {
        // Lasche + Knopf rechts daneben als Gruppe mittig im freien Bereich links der Karte
        const pr = panel.getBoundingClientRect(), st = stage.getBoundingClientRect();
        const free = pr.left - st.left, half = heroH * it.ar * .45, gap = 32, cw = q('cta').offsetWidth;
        hx = Math.max(half + 24, (free - (half * 2 + gap + cw)) / 2 + half);
        stage.style.setProperty('--cx', `${hx + half + gap}px`);
        stage.style.setProperty('--cy', `${sh * hb - 14 - heroH * it.foot / 2}px`);
      }
      stage.style.setProperty('--hx', `${hx}px`);
      stage.style.setProperty('--hbase', `${hb * 100}%`);
    }
    function showHero(i) {
      const it = items[i], src = btns[i].dataset.hero;
      hero.style.setProperty('--hfoot', it.foot);
      hero.style.setProperty('--har', it.ar);
      if (src) { q('hero-img').src = src; q('hero-refl').src = src; }
      q('hero-img').alt = btns[i].querySelector('.spr-float img')?.alt || '';
      const inner = q('hero-in');
      inner.style.animation = 'none';
      void inner.offsetWidth;
      inner.style.animation = '';
    }
    function select(i) {
      const first = sel < 0;
      sel = (i + items.length) % items.length;
      btns.forEach((b, n) => b.classList.toggle('is-sel', n === sel));
      fillPanel(items[sel]);
      showHero(sel);
      placeHero();
      regal.classList.add('is-open');
      hint.textContent = 'Pfeiltasten wechseln · Esc für Übersicht';
      if (first) q('ptitle').focus({ preventScroll: true });
      if (first && mobileMQ.matches) panel.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }
    function close() {
      if (sel < 0) return;
      sel = -1;
      regal.classList.remove('is-open');
      btns.forEach((b) => b.classList.remove('is-sel'));
      hint.textContent = 'Lasche antippen für Details · die Zughaube in der Mitte passt auf alle';
      setBigtype('Spinny');
      stage.style.setProperty('--spr-tone', '#ffffff');
      (lastBtn || btns[0]).focus({ preventScroll: true });
    }

    btns.forEach((b, i) => {
      b.addEventListener('click', () => { lastBtn = b; select(i); });
      b.addEventListener('animationend', (e) => { if (e.animationName === 'spr-rise') b.classList.remove('spr-intro'); });
    });
    q('prev').addEventListener('click', () => select(sel - 1));
    q('next').addEventListener('click', () => select(sel + 1));
    q('close').addEventListener('click', close);
    root.addEventListener('keydown', (e) => {
      if (sel < 0) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') select(sel + 1);
      if (e.key === 'ArrowLeft') select(sel - 1);
    });
    stage.addEventListener('click', (e) => {
      if (sel >= 0 && !mobileMQ.matches && (e.target === stage || e.target.classList.contains('spr-floor'))) close();
    });
    addEventListener('resize', () => { if (sel >= 0) placeHero(); });

    if (!reduce && matchMedia('(hover: hover)').matches) {
      stage.addEventListener('pointermove', (e) => {
        const r = stage.getBoundingClientRect();
        stage.style.setProperty('--px', (((e.clientX - r.left) / r.width) * 2 - 1).toFixed(3));
        stage.style.setProperty('--py', (((e.clientY - r.top) / r.height) * 2 - 1).toFixed(3));
      });
      stage.addEventListener('pointerleave', () => { stage.style.setProperty('--px', 0); stage.style.setProperty('--py', 0); });
    }

    // Direktlink, z. B. nivilli.com/#aussen-4mm-gruen
    const fromHash = items.findIndex((it) => it.id === decodeURIComponent(location.hash.slice(1)));
    if (fromHash >= 0) { lastBtn = btns[fromHash]; select(fromHash); }
  }

  const boot = () => document.querySelectorAll('[data-spr]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-spr]')));
})();
